<template>
  <div class="dashboard-layout">
    <Header />
    <main>
      <slot />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'Dashboard',
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.dashboard-layout {
  height: 100%;
  min-height: 100vh;
  background: $blue;
  background: linear-gradient(
    180deg,
    $blue 0px,
    $blue 240px,
    #D5DEEB 240px
  );
}

main {
  height: 100%;
  padding-top: 80px;
  padding-bottom: 45px;

  @media print {
    padding-top: 25px;
    padding-bottom: 0;
  }
}
</style>
